module.exports = "https://www.gc-qa.gnp.com.mx/7b7c4b167f347b0395613c3cda561bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-back.png
// module id = 322
// module chunks = 0